import { render, staticRenderFns } from "./wxUserAddEdit.vue?vue&type=template&id=19a8535a"
import script from "./wxUserAddEdit.vue?vue&type=script&lang=js"
export * from "./wxUserAddEdit.vue?vue&type=script&lang=js"
import style0 from "./wxUserAddEdit.vue?vue&type=style&index=0&id=19a8535a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports